import React from "react";

const LAYOUTS = [
  { key: "list", label: "List" },
  { key: "board", label: "Board" },
];

// List/Board switch plus the "Customize sections" entry point.
export default function TasksToolbar({
  layout,
  onLayoutChange,
  onCustomize,
  customizeLabel = "Customize sections",
  children,
}) {
  return (
    <div className="tk-tasks-toolbar">
      <div className="tk-scope-pills" role="tablist" aria-label="Layout">
        {LAYOUTS.map((l) => (
          <button
            key={l.key}
            type="button"
            role="tab"
            aria-selected={layout === l.key}
            className={layout === l.key ? "active" : ""}
            onClick={() => onLayoutChange(l.key)}
          >
            {l.label}
          </button>
        ))}
      </div>
      <div className="tk-tasks-toolbar-right">
        {children}
        <button
          type="button"
          className="btn-secondary btn-sm"
          onClick={onCustomize}
        >
          {customizeLabel}
        </button>
      </div>
    </div>
  );
}
